import type {
  QueryUserLoginInformationModel,
  UserLoginInformationModel,
} from '@/api/system/model/userLoginInformationModel'
import type { UserInformationModel } from '@/api/model/userInformationMode'
import { parseJWT } from '@/utils'
import { queryUserLoginInformation } from '@/api/system/userLoginInformation'
import { parseRoleIDList } from '@/utils/jwt'
import { useLoginUser, useStorage } from '@/hooks/core'
import { CharBoolean } from '@/enums'

export const authorizatedInitiate = async (
  idToken: string,
  isChangeTokenOnly: boolean
): Promise<void> => {
  const { saveUserLoginInformation, saveUserInformation } = useStorage()
  const { corporatorsInfo, setCorporatorsInfo } = useLoginUser()

  const userInformation = parseJWT<UserInformationModel>(idToken)

  // トークンからユーザー情報を取得できない場合はログイン失敗と見なしアプリを中断
  if (!userInformation?.oid) {
    console.warn('fail to get userInformation from id token.')
    return
  }

  // トークンから解析したユーザー情報をストレージに保存
  saveUserInformation(userInformation)

  if (isChangeTokenOnly || corporatorsInfo.value.length) {
    return
  }

  const roleIDList = parseRoleIDList(
    userInformation.extension_dpf_role_id_list.toString()
  )

  // ユーザー情報でログイン情報を取得し、ストレージに保存
  const loginInformation: QueryUserLoginInformationModel | string =
    await queryUserLoginInformation({
      corporateNumber: roleIDList.corporateNumber,
      userID: userInformation.extension_dpf_user_id,
      roleCode: roleIDList.roleCode,
    })

  if (typeof loginInformation === 'string') {
    console.warn(loginInformation)
    return
  }

  if (loginInformation.detail.length < 1) {
    console.warn('fail to get login information.')
    return
  }

  setCorporatorsInfo(loginInformation.detail)

  const defaultCorporator: UserLoginInformationModel | undefined =
    loginInformation.detail.find(
      (item: UserLoginInformationModel): boolean =>
        item.default_corporate_flag === CharBoolean.TRUE
    )

  saveUserLoginInformation(defaultCorporator ?? loginInformation.detail[0])
}
